import { useEffect, useState } from "react";
import { fetchLeaderboard } from "@/lib/leaderboard";
import type { LeaderboardFilters, LeaderboardPayload } from "@/types/leaderboard";

export function useLeaderboard(filters: LeaderboardFilters = {}) {
  const [data, setData] = useState<LeaderboardPayload | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // serialize filters for the deps array
  const key = JSON.stringify(filters);

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    setError(null);
    fetchLeaderboard(filters)
      .then((d) => { if (!cancel) setData(d); })
      .catch((e: unknown) => { if (!cancel) setError(e instanceof Error ? e.message : String(e)); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { data, loading, error };
}
